import {
  BaseSelectProps,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from "@mui/material";
import React from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { StyledSelect } from "./styles";

interface MenuArray {
  value: string | number;
  label: string;
}

//@ts-ignore
interface IFutSelect<T extends FieldValues> extends BaseSelectProps {
  control?: Control<T>;
  inputName?: Path<T>;
  data: MenuArray[];
  placeholderItem?: string;
}

export default function FutSelect<T extends FieldValues>({
  control,
  inputName,
  data,
  placeholderItem,
  ...props
}: IFutSelect<T>) {
  return inputName && control ? (
    <Controller
      name={inputName}
      control={control}
      render={({ field }) => (
        <>
          <StyledSelect
            {...field}
            size="small"
            renderValue={
              placeholderItem
                ? (selected: any) => {
                    if (!selected) {
                      return <em>{placeholderItem}</em>;
                    }

                    return selected;
                  }
                : undefined
            }
            displayEmpty={!!placeholderItem}
            {...props}
          >
            {placeholderItem ? (
              <MenuItem disabled value="">
                <em>{placeholderItem}</em>
              </MenuItem>
            ) : null}
            {data.map((el) => (
              <MenuItem key={el.value + el.label} value={el.value}>
                {el.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </>
      )}
    />
  ) : (
    <StyledSelect size="small" {...props}>
      {data.map((el) => (
        <MenuItem key={el.value + el.label} value={el.value}>
          {el.label}
        </MenuItem>
      ))}
    </StyledSelect>
  );
}
